import { defineMessages } from "react-intl"

export default defineMessages({
	mobile_trade: {
		id: "app.components.exchangeMobile.label.trade",
		defaultMessage: "Trade",
	},
	mobile_currency: {
		id: "app.components.MobileExchange.pairs.currency",
		defaultMessage: "Currency",
	},
	mobile_deals: {
		id: "app.common.containers.deals",
		defaultMessage: "Deals",
	},
	mobile_chat: {
		id: "app.components.Exchange.chat.chat",
		defaultMessage: "Chat",
	},
	mobile_wallets: {
		id: "app.components.Exchange.chat.wallets",
		defineMessages: "Wallets",
	},
	margin_risks_important: {
		id: "app.containers.trading.margin_risks.important",
		defaultMessage: "Important",
	},
	margin_risks_label: {
		id: "app.containers.trading.margin_risks.label",
		defaultMessage: "Margin trading is accompanied by high risk",
	},
	margin_risks_verification: {
		id: "app.containers.trading.margin_risks.verification",
		defaultMessage: "You will also need to complete {verification_label}",
	},
	margin_risks_verification_level: {
		id: "app.containers.trading.margin_risks.verification_label",
		defaultMessage: "Verification level {level}",
	},
	margin_risks_pass_verification: {
		id: "app.containers.trading.margin_risks.pass_verification",
		defaultMessage: "Complete verification level {level}",
	},
	margin_risks_terms_of_agreement_policy: {
		id: "app.containers.trading.margin_risks.terms_of_agreement_policy",
		defaultMessage: "Terms of agreement policy",
	},
	margin_risks_terms_confirmation: {
		id: "app.containers.trading.margin_risks.terms_confirmation",
		defaultMessage: "I understand the risks and accept {terms_of_agreement_policy}",
	},
	margin_trade_faq_desc: {
		id: "app.containers.terminal.margin_trade_faq_desc",
		defaultMessage: "Learn more about margin trading",
	},
	exchange: {
		id: "app.containers.Exchange.header",
		defaultMessage: "Exchange",
	},
	margin: {
		id: "app.containers.Exchange.margin",
		defaultMessage: "Margin",
	},
	currency: {
		id: "app.components.Exchange.pairs.currency",
		defaultMessage: "Currency",
	},
	chat: {
		id: "app.components.Exchange.chat.chat",
		defaultMessage: "Chat",
	},
	wallets: {
		id: "app.components.Exchange.chat.wallets",
		defaultMessage: "Wallets",
	},
	refill: {
		id: "app.components.Exchange.chat.refill",
		defaultMessage: "Refill",
	},
	all_accounts: {
		id: "app.components.Exchange.chat.all_accounts",
		defaultMessage: "All accounts",
	},
	twitter: {
		id: "app.components.Exchange.chat.twitter",
		defaultMessage: "Twitter",
	},
	order_price: {
		id: "app.components.Exchange.pairs.order_price",
		defaultMessage: "Order Price",
	},
	limit_price: {
		id: "app.components.Exchange.pairs.limit_price",
		defaultMessage: "Limit price",
	},
	trigger_price: {
		id: "app.components.Exchange.pairs.trigger_price",
		defaultMessage: "Trigger price",
	},
	volume_chart: {
		id: "app.components.Exchange.chart.volume",
		defaultMessage: "VOL",
	},
	rating_chart: {
		id: "app.components.Exchange.chart.rating",
		defaultMessage: "Revain rating",
	},
	site: {
		id: "app.components.Exchange.chart.site",
		defaultMessage: "Site",
	},
	details: {
		id: "app.components.Exchange.chart.details",
		defaultMessage: "Details",
	},
	buy_orders: {
		id: "app.components.Exchange.buy_orders.buy_orders",
		defaultMessage: "Buy Orders",
	},
	sell_orders: {
		id: "app.components.Exchange.buy_orders.sell_orders",
		defaultMessage: "Sell Orders",
	},
	amount: {
		id: "app.components.Exchange.orders.amount",
		defaultMessage: "Amount",
	},
	depth: {
		id: "app.components.Exchange.orders.depth",
		defaultMessage: "Depth",
	},
	total: {
		id: "app.components.Exchange.orders.total",
		defaultMessage: "Total",
	},
	buy: {
		id: "app.components.Exchange.form.buy",
		defaultMessage: "Buy",
	},
	cross: {
		id: "app.components.Exchange.form.cross",
		defaultMessage: "Cross",
	},
	sell: {
		id: "app.components.Exchange.form.sell",
		defaultMessage: "Sell",
	},
	long: {
		id: "app.components.Exchange.form.long",
		defaultMessage: "Long",
	},
	short: {
		id: "app.components.Exchange.form.short",
		defaultMessage: "Short",
	},
	get: {
		id: "app.components.Exchange.form.get",
		defaultMessage: "Get",
	},
	give: {
		id: "app.components.Exchange.form.give",
		defaultMessage: "Give",
	},
	last_price: {
		id: "app.components.Exchange.form.last_price",
		defaultMessage: "Last price",
	},
	balance: {
		id: "app.components.Exchange.form.balance",
		defaultMessage: "Balance",
	},
	max_buying_amount: {
		id: "app.components.Exchange.form.max_buying_amount",
		defaultMessage: "Max. buying amount",
	},
	max_selling_amount: {
		id: "app.components.Exchange.form.max_selling_amount",
		defaultMessage: "Max. selling amount",
	},
	margin_cross_trading_account: {
		id: "app.components.Exchange.form.margin_cross_trading_account",
		defaultMessage: "Margin Cross Trading Account",
	},
	margin_isolated_trading_account: {
		id: "app.components.Exchange.form.margin_isolated_trading_account",
		defaultMessage: "Margin Isolated Trading Account",
	},
	initial_margin: {
		id: "app.components.Exchange.form.initial_margin",
		defaultMessage: "Initial Margin",
	},
	maintenance_margin: {
		id: "app.components.Exchange.form.maintenance_margin",
		defaultMessage: "Maintenance Margin",
	},
	all_borrow_size: {
		id: "app.components.Exchange.form.all_borrow_size",
		defaultMessage: "All Borrow Size",
	},
	spot: {
		id: "app.components.dashboard.spot",
		defaultMessage: "Spot",
	},
	cross_margin: {
		id: "app.containers.finance.margin_cross",
		defaultMessage: "Margin Cross",
	},
	isolated_margin: {
		id: "app.containers.finance.isolated_margin",
		defaultMessage: "Isolated",
	},
	active_orders: {
		id: "app.components.Exchange.active_orders.active_orders",
		defaultMessage: "Active Orders",
	},
	recent_trades: {
		id: "app.components.Exchange.recent_trades.recent_trades",
		defaultMessage: "Recent Trades",
	},
	mobile_chart: {
		id: "app.components.exchangeMobile.label.chart",
		defaultMessage: "Chart",
	},
	date: {
		id: "app.components.exchangeMobile.recent_trades.date",
		defaultMessage: "Date",
	},
	type: {
		id: "app.components.exchangeMobile.recent_trades.TYPE",
		defaultMessage: "type",
	},
	order_created: {
		id: "app.components.exchangeMobile.order_created",
		defaultMessage: "Order created",
	},
	order_created_done: {
		id: "app.components.exchangeMobile.order_created_done",
		defaultMessage: "Order created and done",
	},
	order_done: {
		id: "app.components.exchange.order_done",
		defaultMessage: "Order done",
	},
	mobile_trade_login: {
		id: "app.components.exchange.mobile_trade_login",
		defaultMessage: "Please login to see your balance",
	},
	only: {
		id: "app.components.exchange.pairs.only_favorite",
		defaultMessage: "Only",
	},
	commission: {
		id: "app.components.exchange.trade_widget.commission",
		defaultMessage: "Commission",
	},
	order_book: {
		id: "app.components.exchange.order_book",
		defaultMessage: "Order book",
	},
	exchange_rules: {
		id: "app.components.exchange.exchange_rules",
		defaultMessage: "Trading Rules",
	},
	stop_price: {
		id: "app.components.exchange.stop_price",
		defaultMessage: "Stop price",
	},
	stop_limit_order_desc: {
		id: "app.components.exchange.stop_limit_order_desc",
		defaultMessage:
			"Stop-Limit order is an order for buying or selling a coin, which is executed when the price reaches a specified threshold.",
	},
	exchange_form_login_msg: {
		id: "app.components.exchange.exchange_form_login_msg",
		defaultMessage: "{link1} or {link2}",
	},
	order_type_limit: {
		id: "app.components.exchange.order_type_limit",
		defaultMessage: "Limit",
	},
	order_type_stop_limit: {
		id: "app.components.exchange.order_type_stop_limit",
		defaultMessage: "Stop-Limit",
	},
	order_type_stop_order: {
		id: "app.components.exchange.order_type_stop_order",
		defaultMessage: "Stop-Order",
	},
	order_type_stop_market: {
		id: "app.components.exchange.order_type_stop_market",
		defaultMessage: "Stop-Market",
	},
	order_type_market: {
		id: "app.components.exchange.order_type_market",
		defaultMessage: "Market",
	},
	order_action_type_normal: {
		id: "app.components.exchange.action_type.normal",
		defaultMessage: "Normal",
	},
	order_action_type_borrow: {
		id: "app.components.exchange.action_type.borrow",
		defaultMessage: "Borrow",
	},
	order_action_type_repay: {
		id: "app.components.exchange.action_type.repay",
		defaultMessage: "Repay",
	},
	action_margin_repay: {
		id: "app.components.exchange.action_margin_repay",
		defaultMessage: "Repay",
	},
	action_margin_deposit: {
		id: "app.components.exchange.action_margin_deposit",
		defaultMessage: "Deposit",
	},
	action_margin_transfer: {
		id: "app.components.exchange.action_margin_transfer",
		defaultMessage: "Transfer",
	},
	wallets_no_data: {
		id: "app.common.containers.wallets.no_data",
		defaultMessage: "It’s still empty. Create {link}",
	},
	borrow: {
		id: "app.components.exchange.borrow",
		defaultMessage: "Borrow",
	},
	available_pairs: {
		id: "app.containers.terminal.available_pairs",
		defaultMessage: "Available pairs",
	},
	all_pairs: {
		id: "app.containers.terminal.all_pairs",
		defaultMessage: "All pairs",
	},
	amount_successfuly_submitted: {
		id: "app.components.exchange.amount_successfuly_submitted",
		defaultMessage: "Amount successfuly submitted",
	},
	borrow_more: {
		id: "app.components.exchange.borrow_more",
		defaultMessage: "Borrow More",
	},
	borrow_warning: {
		id: "app.components.exchange.borrow_warning",
		defaultMessage:
			"Investors should be aware of the risk involved in margin trading and read Margin Trading Rules carefully. {link}",
	},
	trade_pair: {
		id: "app.components.exchange.trade_pair",
		defaultMessage: "Trade Pair",
	},
	fee: {
		id: "app.components.exchange.fee",
		defaultMessage: "Fee",
	},
	pair: {
		id: "app.components.exchange.pair",
		defaultMessage: "Pair",
	},
	coin: {
		id: "app.components.exchange.coin",
		defaultMessage: "Coin",
	},
	asset: {
		id: "app.components.exchange.asset",
		defaultMessage: "Asset",
	},
	borrowed: {
		id: "app.components.exchange.borrowed",
		defaultMessage: "Borrowed",
	},
	borrow_daily_rate_hint: {
		id: "app.components.exchange.borrow_daily_rate_hint",
		defaultMessage:
			"Loan Rate is the percentage of the fees you need to pay for the loan. This rate is calculated by 1 hours",
	},
	borrow_hourly_rate_hint: {
		id: "app.components.exchange.borrow_hourly_rate_hint",
		defaultMessage:
			"Loan Rate is the percentage of the fees you need to pay for the loan. This rate is calculated by 1 hours",
	},
	borrow_maximum_hint: {
		id: "app.components.exchange.borrow_maximum_hint",
		defaultMessage: "Available Loans = Effective Margin - Amount Loaned",
	},
	borrow_maximum: {
		id: "app.components.exchange.borrow_maximum",
		defaultMessage: "Maximum Borrow Amount",
	},
	borrow_daily_rate: {
		id: "app.components.exchange.borrow_daily_rate",
		defaultMessage: "Daily rate",
	},
	borrow_hourly_rate: {
		id: "app.components.exchange.borrow_hourly_rate",
		defaultMessage: "Hourly Interested Rate",
	},
	repay: {
		id: "app.components.exchange.repay",
		defaultMessage: "Repay",
	},
	repay_more: {
		id: "app.components.exchange.repay_more",
		defaultMessage: "Repay More",
	},
	interest: {
		id: "app.components.exchange.interest",
		defaultMessage: "Interest",
	},
	total_debt: {
		id: "app.components.exchange.total_debt",
		defaultMessage: "Total Debt",
	},
	available: {
		id: "app.components.exchange.available",
		defaultMessage: "Available",
	},
	transfer_to_spot_success: {
		id: "app.components.exchange.transfer_to_spot_success",
		defaultMessage: "Transfer to spot balance has been successfully completed",
	},
	transfer_to_margin_success: {
		id: "app.components.exchange.transfer_to_margin_success",
		defaultMessage: "Transfer to margin balance has been successfully completed",
	},
	from: {
		id: "app.components.exchange.from",
		defaultMessage: "From",
	},
	to: {
		id: "app.components.exchange.to",
		defaultMessage: "To",
	},
	margin_level: {
		id: "app.components.exchange.margin_level",
		defaultMessage: "Margin Level",
	},
	transfer: {
		id: "app.components.exchange.transfer",
		defaultMessage: "Transfer",
	},
	positions: {
		id: "app.components.exchange.positions",
		defaultMessage: "Positions",
	},
	position_direction: {
		id: "app.components.exchange.position_direction",
		defaultMessage: "Direction",
	},
	position_base_price: {
		id: "app.components.exchange.position_base_price",
		defaultMessage: "Base Price",
	},
	position_index_price: {
		id: "app.components.exchange.position_index_price",
		defaultMessage: "Index Price",
	},
	position_liq_price: {
		id: "app.components.exchange.position_liq_price",
		defaultMessage: "LIQ Price",
	},
	position_p_n_l: {
		id: "app.components.exchange.position_p_n_l",
		defaultMessage: "P&L",
	},
	allowed_trading_pairs: {
		id: "app.containers.terminal.allowed_trading_pairs",
		defaultMessage: "Allowed trading pairs",
	},
	quick_order_placement: {
		id: "app.containers.terminal.quick_order_placement",
		defaultMessage:
			"Quick Order Placement (Market Order).\n Please note that your filled buy quantity may differ slightly from the order quantity you've entered.",
	},
	margin_cross_trading_tooltip: {
		id: "app.containers.terminal.margin_cross_trading_tooltip",
		defaultMessage:
			"Margin Cross Trading Account allows you to use all currencies available in your wallet as collateral. Liquidation may affect all funds in the Margin Cross Trading Account.",
	},
	margin_isolated_trading_tooltip: {
		id: "app.containers.terminal.margin_isolated_trading_tooltip",
		defaultMessage:
			"Margin Isolate Trading Account allows you to keep the collateral separately in each pair. Liquidation can only affect funds that are found in the collateral of a particular pair.",
	},
	avaliable_balance_tooltip: {
		id: "app.containers.terminal.avaliable_balance_tooltip",
		defaultMessage: "Available balance = Available (Margin Account) + Max. Borrowable Amount",
	},
	max_buying_amount_tooltip: {
		id: "app.containers.terminal.max_buying_amount_tooltip",
		defaultMessage:
			"Max. buying amount = Amount in the base currency which we can buy with maximum available leverage",
	},
	max_selling_amount_tooltip: {
		id: "app.containers.terminal.max_selling_amount_tooltip",
		defaultMessage:
			"Max. selling amount = Amount in quote currency which we can sell with maximum available leverage",
	},
	all_borrows_tooltip: {
		id: "app.containers.terminal.all_borrows_tooltip",
		defaultMessage: "The sum of all borrows converted to USDC",
	},
	release_date: {
		id: "app.containers.terminal.release_date",
		defaultMessage: "Release Date",
	},
	supply_limit: {
		id: "app.containers.terminal.supply_limit",
		defaultMessage: "Supply Limit",
	},
	market_cap: {
		id: "app.containers.terminal.market_cap",
		defaultMessage: "Market Cap",
	},
})
